<template>
  <v-container fluid>
    <div class="text-h5 mt-9 ml-2">{{ $t("AddRoomAvailability") }}</div>
    <div class="body-1 mb-5 ml-2">{{ $t("AddRoomAvailabilityHelp") }}</div>
    <div class="mb-10">
      <v-chip large label color="blue-grey lighten-4" class="ma-2">{{
        $t("Unavailable")
      }}</v-chip>
      <v-chip large label color="light-green" class="ma-2">{{
        $t("Available")
      }}</v-chip>
      <v-chip large label color="orange" class="ma-2">{{
        $t("Booked")
      }}</v-chip>
    </div>
    <v-alert dense outlined type="error" v-if="error">
      <ul>
        <li v-for="item in error" :key="item.msg">{{ $t(item.msg) }}</li>
      </ul>
    </v-alert>
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <div class="mb-16 pb-10">
      <v-toolbar flat>
        <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
          {{ $t("Today") }}
        </v-btn>
        <v-btn fab text small color="light-blue" @click="prev">
          <v-icon small> mdi-chevron-left </v-icon>
        </v-btn>
        <v-btn fab text small color="light-blue" @click="next">
          <v-icon small> mdi-chevron-right </v-icon>
        </v-btn>
        <v-toolbar-title v-if="$refs.calendar">
          {{ $refs.calendar.title }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          class="ml-4"
          color="light-blue"
          dark
          @click="addBulkAvailability"
        >
          {{ $t("Addfullmonth") }}
        </v-btn>
      </v-toolbar>
      <v-calendar
        ref="calendar"
        v-model="focus"
        color="primary"
        :type="type"
        @change="moved"
      >
        <template
          v-slot:day-label="{ day, date, present, past, future }"
          class="mt-0"
        >
          <v-card elevation="0" height="60" width="100%" class="relative">
            <v-tooltip top v-if="blockedDates.includes(date)">
              <template v-slot:activator="{ on }">
                <v-row
                  v-on="on"
                  class="fill-height ma-0 subtitle-1 orange"
                  align="center"
                  justify="center"
                  >{{ day }}
                </v-row>
              </template>
              <span>{{ $t("Alreadybooked") }}</span>
            </v-tooltip>
            <v-row
              v-if="future && availableDates.includes(date)"
              @click="removeAvailability(date)"
              class="fill-height ma-0 subtitle-1 light-green clickbleItem"
              align="center"
              justify="center"
              >{{ day }}
            </v-row>
            <v-row
              v-if="future && !availableDates.includes(date)"
              @click="addAvailability(date)"
              class="fill-height ma-0 subtitle-1 blue-grey lighten-4 clickbleItem"
              align="center"
              justify="center"
              >{{ day }}
            </v-row>
            <v-row
              v-if="present || past"
              class="fill-height ma-0 subtitle-1 blue-grey lighten-5 text--disabled crossClass"
              align="center"
              justify="center"
              >{{ day }}</v-row
            >
          </v-card>
        </template>
      </v-calendar>
      <v-footer fixed>
        <v-col class="text-center" cols="12">
          <v-btn
            color="light-blue"
            dark
            min-width="150"
            :to="{
              name: 'PartnerListingViewComponent',
              params: { id: parm }
            }"
          >
            <span>{{ $t("Done") }}</span>
          </v-btn>
        </v-col>
      </v-footer>
    </div>
    <WaitDialogComponent :waitDialog="waitDialog" />
  </v-container>
</template>

<script>
import timeoutMixin from "@/mixins/timeoutMixin.js";
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import BookingService from "@/services/BookingService";
import { format } from "date-fns";

export default {
  name: "EditAvailabilityComponent",
  mixins: [timeoutMixin],
  components: { WaitDialogComponent },
  data() {
    return {
      format,
      loading: true,
      parm: this.$route.params.id,
      focus: "",
      type: "month",
      waitDialog: false,
      error: null,
      dates: [],
      availableDates: [],
      blockedDates: [],
      events: []
    };
  },
  created: function() {
    BookingService.getAvailability({
      property_id: this.parm
    })
      .then(result => {
        this.events = result.data;
        this.events.forEach(e => {
          if (e.available) {
            this.availableDates.push(e.date_string);
          } else {
            this.blockedDates.push(e.date_string);
          }
        });
        this.loading = false;
      })
      .catch(err => {
        this.error = err.response.data.errors;
      });
  },
  mounted() {
    this.$refs.calendar.move(0);
  },
  methods: {
    moved(data) {
      this.dates = [];
      for (var i = 1; i <= data.end.day; i++) {
        if (i <= 9) i = "0" + i;
        var month = data.end.month;
        if (month <= 9) month = "0" + month;
        this.dates.push(data.end.year + "-" + month + "-" + i);
      }
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    addAvailability(val) {
      this.waitDialog = true;
      BookingService.addAvailability({
        date: val,
        property_id: this.parm
      })
        .then(result => {
          this.waitDialog = false;
          this.events = result.data;
          this.availableDates = this.events.map(e => e.date_string);
        })
        .catch(err => {
          this.error = err.response.data.errors;
          this.waitDialog = false;
        });
    },
    removeAvailability(val) {
      BookingService.removeAvailability({
        date: val,
        property_id: this.parm
      })
        .then(result => {
          this.waitDialog = false;
          this.events = result.data;
          this.availableDates = this.events.map(e => e.date_string);
        })
        .catch(err => {
          this.error = err.response.data.errors;
          this.waitDialog = false;
        });
    },
    addBulkAvailability() {
      this.waitDialog = true;
      BookingService.addBulkBooking({
        dates: this.dates,
        property_id: this.parm
      })
        .then(result => {
          this.waitDialog = false;
          this.events = result.data;
          this.availableDates = this.events.map(e => e.date_string);
        })
        .catch(err => {
          this.error = err.response.data.errors;
          this.waitDialog = false;
        });
    }
  }
};
</script>

<style>
.crossClass:hover {
  cursor: not-allowed !important;
}
.crossClass::after {
  position: absolute;
  content: "";
  width: 300px;
  height: 2px;
  background-color: #d5cfcf;
  transform: rotateZ(20deg);
}
.crossClass::before {
  position: absolute;
  content: "";
  width: 300px;
  height: 2px;
  background-color: #d5cfcf;
  transform: rotateZ(-20deg);
}
.crossClass {
  position: relative;
}
.v-application .clickbleItem:hover {
  border: 3px solid #000 !important;
}
.theme--light.v-calendar-weekly,
.theme--light.v-calendar-weekly .v-calendar-weekly__day {
  border-color: #fff !important;
}
.theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday {
  font-size: 18px;
  color: #000 !important;
  padding: 5px;
  border-color: #fff !important;
}
.v-calendar-weekly__day-label {
  margin: 1px !important;
  cursor: not-allowed;
}
.v-future .v-calendar-weekly__day-label {
  cursor: pointer;
}
.theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday.v-outside {
  background-color: #fff !important;
}
.theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside {
  visibility: hidden;
}
</style>
